var map = {
	"./Refund.svg": "dFU7",
	"./cm.svg": "2Yrr",
	"./cm_active.svg": "WEWW",
	"./dd.svg": "BzSL",
	"./ddxq.svg": "x3OG",
	"./ddxq_active.svg": "QX9r",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./fenlei.svg": "tQPi",
	"./form.svg": "sTIr",
	"./fuwu.svg": "RJbI",
	"./home.svg": "U9Ws",
	"./home_active.svg": "kH3i",
	"./iconkh1.svg": "hSRC",
	"./jiaoseguanli.svg": "X/OC",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./mendian.svg": "Z0v4",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./pd.svg": "2JU6",
	"./pd_active.svg": "Q223",
	"./peijianguanli.svg": "01py",
	"./pj.svg": "kuRO",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./pt.svg": "TQgH",
	"./ptxq.svg": "U4O7",
	"./quanxianguanli.svg": "9RtP",
	"./sb.svg": "05dd",
	"./sb_active.svg": "jIL7",
	"./sm.svg": "kG+/",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3",
	"./weibiaoti2fuzhi01.svg": "Ifu+",
	"./xiaochengxu.svg": "BiWf",
	"./xitong.svg": "z8FN",
	"./xsqg.svg": "R43A",
	"./xsqgxq.svg": "m45+",
	"./yhq.svg": "KK0k",
	"./yhqgl.svg": "jjjA",
	"./yhqhd.svg": "nHw7",
	"./yhqjl.svg": "gi5c"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 16